/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * A payload of actorRIDs to get client entities
 * @export
 * @interface FindClientsForActorsRequest
 */
export interface FindClientsForActorsRequest {
	/**
	 *
	 * @type {Array<string>}
	 * @memberof FindClientsForActorsRequest
	 */
	actorRIDs?: Array<string>;
}

/**
 * Check if a given object implements the FindClientsForActorsRequest interface.
 */
export function instanceOfFindClientsForActorsRequest(value: object): boolean {
	let isInstance = true;

	return isInstance;
}

export function FindClientsForActorsRequestFromJSON(
	json: any
): FindClientsForActorsRequest {
	return FindClientsForActorsRequestFromJSONTyped(json, false);
}

export function FindClientsForActorsRequestFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): FindClientsForActorsRequest {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		actorRIDs: !exists(json, 'actorRIDs') ? undefined : json['actorRIDs'],
	};
}

export function FindClientsForActorsRequestToJSON(
	value?: FindClientsForActorsRequest | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		actorRIDs: value.actorRIDs,
	};
}
